export class Language {
    public languages: string[] = [];
}
